"use client";

import posthog from "posthog-js";
import Link from "next/link";
import { useEffect } from "react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    if (process.env.NEXT_PUBLIC_POSTHOG_KEY) {
      posthog.captureException(error);
    }
  }, [error]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background px-6">
      <div className="flex flex-col items-center gap-6 text-center max-w-md">
        <div className="flex flex-col gap-2">
          <h1 className="text-xl font-semibold text-foreground">
            Une erreur est survenue
          </h1>
          <p className="text-sm text-muted-foreground">
            L&apos;équipe a été notifiée. Vous pouvez réessayer ou retourner au
            tableau de bord.
          </p>
          {error.digest ? (
            <p className="text-xs font-mono text-muted-foreground/70 mt-2">
              Ref : {error.digest}
            </p>
          ) : null}
        </div>

        <div className="flex gap-3">
          <button
            onClick={() => reset()}
            className="inline-flex items-center justify-center h-9 px-5 rounded-[var(--radius)] bg-primary text-primary-foreground text-sm font-medium hover:bg-primary/90 transition-colors"
          >
            Réessayer
          </button>
          <Link
            href="/dashboard"
            className="inline-flex items-center justify-center h-9 px-5 rounded-[var(--radius)] border border-border bg-background text-foreground text-sm font-medium hover:bg-muted transition-colors"
          >
            Tableau de bord
          </Link>
        </div>
      </div>
    </div>
  );
}
